<div #pbContainer class="power-bi-container"></div>